(function Videos($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/MyTrips/videos'], function onload()
		{
			$('.video').click(function showVideo(e) {
				var $self          = $(this),
					$modal         = $(".modal"),
					title          = $self.data("title"),
					iframe_src     = $self.data("iframe-src"),
					iframe_height  = $self.data("iframe-height") || 500,
					iframe_width   = $self.data("iframe-width") || '100%';

				e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});
	});
}(jQuery, window.Adzuki || {}));